import { TransferMealLine } from '../../lib/types/models/transfer-meal/transfer-meal'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function previewTransferMeal(tripFolderId: number, transferPlaceIds: number[]) {
  return restApiClient
    .url(constructApiUrl(API.transferMeal.preview.url, { tripFolderId }))
    .post<TransferMealLine[]>({ transferPlaceIds })
}
